module.exports = __webpack_public_path__ + "img/cpany1.e1638cb5.png";